<template>

  <span>

	<LinkWithIcon 
		:settings="settings"
		:styles="linkStyles"
		:hideIcons="hideIcons"
		@clicked="clicked"
	/>

	<br v-if="isLastRanked" /><span v-if="isLastRanked" class="last-ranked" v-html="settings.lastRanked" />

  </span>

</template>
<script>
import LinkWithIcon from './LinkWithIcon.vue'
export default {
  name: 'KeywordURL',
  props: {
    settings: {
      type: Object
    },
    hideIcons: {
      type: Boolean,
      default: false
    }
  },
  components:{LinkWithIcon},
  data() {
  	return {
  	  
  	}
  },
  computed:{
	linkStyles () {
		let s = {};
		if ( this.isLastRanked ) s.opacity = 0.7;
		return s;
	},
	isLastRanked () {
		
		return !!this.settings.lastRanked;

	}
  },
  methods: {

    clicked() {
      
      this.$emit('clicked',this.settings);

    }

  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
.last-ranked{
	font-size: 10px;
	opacity: 0.7;
}
</style>